<template>
    <v-row style="">
        <v-col class="col-6 col-md-3" v-for="(card,index) in data" :key="index" style="width:200px;">
            <CollectionCard
                    v-if="card!==undefined && card.TYPE===0"
                    :data=card
                    v-on:clicked="collectionClicked"
                    :animate=true

                    :style="{'transform':$vuetify.breakpoint.mdAndDown?'scale(0.7)':''}"

                    :list_index=index
            ></CollectionCard>
            <SBCard
                    v-if="card!==undefined && card.TYPE===3"
                    :data=card
                    v-on:clicked="sbClicked"
                    :animate=true

                    :style="{'transform':$vuetify.breakpoint.mdAndDown?'scale(0.7)':''}"

                    :list_index=index
            ></SBCard>
            <ActionCard
                    v-if="card!==undefined && card.TYPE===1"
                    :data=card
                    :editable=false
                    v-on:clicked="actionClicked"
                    :list_index=index
                    :style="{'transform':$vuetify.breakpoint.mdAndDown?'scale(0.7)':''}"



            ></ActionCard>
            <Pack
                    v-if="card!==undefined && card.TYPE===2"
                    :data=card
                    v-on:clicked="packClicked"
                    style="transform:scale(1);"
                    :list_index=index
                    :style="{'transform':$vuetify.breakpoint.mdAndDown?'scale(0.7)':''}"



            ></Pack>

        </v-col>

    </v-row>

</template>

<script>
    import CollectionCard from '../components/CollectionCard'
    import ActionCard from '../components/ActionCard'
    import Pack from '../components/Pack'
    import SBCard from "./SBCard";

    export default {
        components:{
          CollectionCard,
            ActionCard,
            Pack,
            SBCard,
        },

        props:{
            "data":Array
        },
        name: "CardPage",

        computed:{


        },
        watch:{

        },
        methods:{
            actionClicked:function(payload,index){
                this.$emit("actionClicked",payload,index);
            },
            collectionClicked:function(payload,index){
                this.$emit("collectionClicked",payload,index);
            },
            packClicked:function(payload,index){
                this.$emit("packClicked",payload,index);

            },
            sbClicked:function(payload,index){
                this.$emit("sbClicked",payload,index);

            }
        }
    }
</script>

<style scoped>

</style>
